Ext.define('SA.view.filter.ConditionRow', {
    alias: 'widget.filter-condition-row',
    extend: 'Ext.Container',

    cls: 'sa-filters-condition-row',

    saAnim: true,

    defaults: {
        saAnim: {
            add: false
        }
    },

    items: [
        {
            xtype: 'component',
            cls: 'sa-filters-attribute',
            itemId: 'attribute',
            margin: '0 10 0 0',
            minHeight: 54,
            width: 220
        }, {
            xtype: 'combo-button',
            emptyText: Ext.String.repeat('\u00a0', 15),
            height: 54,
            itemId: 'operator',
            margin: '0 8 0 0',
            textField: 'text',
            valueField: 'value',

            items: [
                {
                    text: 'is greater than',
                    value: '>'
                }, {
                    text: 'is less than',
                    value: '<'
                }, {
                    text: 'is equal to',
                    value: '='
                }, {
                    text: 'is greater than or equal to',
                    value: '>='
                }, {
                    text: 'is less than or equal to',
                    value: '<='
                }, {
                    text: 'is not equal to',
                    value: '<>'
                }, {
                    text: 'is between',
                    value: 'between'
                }
            ],

            selectHandler(newOperator) {
                const row = this.up('filter-condition-row'),
                    condition = row.condition,
                    oldOperator = row.getOperator();

                if (!newOperator || oldOperator === newOperator) {
                    return;
                }

                if (oldOperator === 'between') {
                    condition[0] = newOperator;
                    condition[2] = condition[1][2];
                    condition[1] = condition[1][1];
                }
                else if (newOperator === 'between') {
                    condition[0] = 'and';
                    condition[1] = ['>=', condition[1], condition[2]];
                    condition[2] = ['<=', condition[1][1], condition[1][2] + 1];
                }
                else {
                    condition[0] = newOperator;
                }

                row.onChange();
            }
        }, {
            xtype: 'sa-formatted-numberfield',
            enableKeyEvents: true,
            flex: 1,
            height: 54,
            itemId: 'value',
            maskRe: /[\d.$,\-%]/,

            listeners: {
                blur: field => field.up('filter-condition-row').onFirstFieldBlur(),
                keyup: field => field.up('filter-condition-row').onFirstFieldKeyUp()
            }
        }, {
            xtype: 'sa-formatted-numberfield',
            enableKeyEvents: true,
            flex: 1,
            height: 54,
            itemId: 'otherValue',
            margin: '0 0 0 8',
            maskRe: /[\d.$,\-%]/,

            listeners: {
                blur: field => field.up('filter-condition-row').onSecondFieldBlur(),
                keyup: field => field.up('filter-condition-row').onSecondFieldKeyUp()
            }
        }, {
            xtype: 'remove-button',
            margin: '0 0 0 13',

            handler(btn) {
                btn.up('filter-condition-row').onRemoveClick();
            }
        }
    ],

    layout: {
        align: 'middle',
        type: 'hbox'
    },

    beforeRender() {
        this.callParent();

        this.refresh();
    },

    getOperator() {
        const condition = this.condition;
        let operator = condition && condition[0].toLowerCase();

        if (operator === 'and') {
            operator = 'between';
        }

        return operator;
    },

    onChange() {
        this.refresh();

        this.fireEvent('change:condition', this);
    },

    onFirstFieldBlur() {
        if (this.getOperator() !== 'between') {
            return;
        }

        const condition = this.condition;
        const firstValue = condition[1][2];
        const secondValue = condition[2][2];

        if (firstValue >= secondValue) {
            const incrementedValue = firstValue + 1;
            condition[2][2] = incrementedValue;
            const secondValueField = this.down('#otherValue');
            secondValueField.setValue(incrementedValue);
        }

        this.onChange();
    },

    onFirstFieldKeyUp() {
        const field = this.down('#value'),
            newValue = field.getValue() || 0,
            condition = this.condition,
            operator = this.getOperator(),
            isBetween = operator === 'between',
            oldValue = isBetween ? condition[1][2] : condition[2];

        if (newValue === oldValue) {
            return;
        }

        if (isBetween) {
            condition[1][2] = newValue;
        }
        else {
            condition[2] = newValue;
        }

        if (!newValue) {
            field.setValue(0);
        }

        this.onChange();
    },

    onRemoveClick() {
        if (this.removed) {
            return;
        }

        this.removed = true;

        this.fireEvent('remove:condition', this);
    },

    onSecondFieldBlur() {
        if (this.getOperator() !== 'between') {
            return;
        }

        const condition = this.condition;
        const firstValue = condition[1][2];
        const secondValue = condition[2][2];

        if (firstValue >= secondValue) {
            const decrementedValue = Math.max(secondValue - 1, 0);
            condition[1][2] = decrementedValue;
            const firstValueField = this.down('#value');
            firstValueField.setValue(decrementedValue);
        }

        this.onChange();
    },

    onSecondFieldKeyUp() {
        const field = this.down('#otherValue'),
            newValue = field.getValue() || 0,
            condition = this.condition,
            oldValue = condition[2][2];

        if (newValue === oldValue) {
            return;
        }

        condition[2][2] = newValue;

        if (!newValue) {
            field.setValue(0);
        }

        this.onChange();
    },

    refresh() {
        const condition = this.condition,
            attributeCmp = this.down('#attribute'),
            operatorBtn = this.down('#operator'),
            valueField = this.down('#value'),
            otherValueField = this.down('#otherValue'),
            operator = this.getOperator();
        let attribute, value, otherValue;

        Ext.suspendLayouts();

        if (operator === 'between') {



                        attribute = SA.data.AttributesCache.get(condition[1][1]);
            value = condition[1][2];
            otherValue = condition[2][2];

            updateValueField(otherValueField, otherValue);

            otherValueField.show();
        }
        else {
            attribute = SA.data.AttributesCache.get(condition[1]);
            value = condition[2];

            otherValueField.hide();
        }

        attributeCmp.update(`<div>${SA.BadgedAttributeLabel.getHtml({attribute})}</div>`);
        operatorBtn.setValue(operator);

        updateValueField(valueField, value);

        Ext.resumeLayouts(true);

        function updateValueField(field, value) {
            if (field.isFocused()) {
                return;
            }

            if (attribute) {
                field.setFormat(value => {
                    const roundingFactor = 1 / attribute.increments;

                    const roundedValue = Math.round(value * roundingFactor) / roundingFactor;

                    return SA.data.AttributesCache.formatValue(roundedValue, attribute.formatString);
                });

                field.setValue(value);
                field.enable();
            }
            else {
                field.disable();
            }
        }
    }
});